var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBeforeImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 22.6665C19.5425 22.6665 21.3333 20.8756 21.3333 18.6665C21.3333 16.4574 19.5425 14.6665 17.3333 14.6665C15.1242 14.6665 13.3333 16.4574 13.3333 18.6665C13.3333 20.8756 15.1242 22.6665 17.3333 22.6665Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 8.00016H23.7733L22.12 6.20016C21.6267 5.6535 20.9067 5.3335 20.16 5.3335H12C12 6.00012 12 6.66683 12 6.66683V11.0001V13.0001L8.5 12.9602C7 12.9602 7.34 12.9602 5.87333 12.9602C5.38 12.9602 4.5 12.9602 4 12.9602V26.6668C4 28.1335 5.2 29.3335 6.66667 29.3335H28C29.4667 29.3335 30.6667 28.1335 30.6667 26.6668V10.6668C30.6667 9.20016 29.4667 8.00016 28 8.00016ZM17.3333 25.3335C13.6533 25.3335 10.6667 22.3468 10.6667 18.6668C10.6667 14.9868 13.6533 12.0002 17.3333 12.0002C21.0133 12.0002 24 14.9868 24 18.6668C24 22.3468 21.0133 25.3335 17.3333 25.3335Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12L4 8.5L9 5V12Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBeforeImage);
export default __webpack_public_path__ + "static/media/ic_before_image.395ce0f880deaa2f9250d6bcc363d90e.svg";
export { ForwardRef as ReactComponent };